import { Injectable } from '@angular/core'

import { AuthenticatedRestService } from './auth-rest.service'

@Injectable({
  providedIn: 'root',
})
export class PatientAccountClearanceService extends AuthenticatedRestService {
  public rerunPatientAccountClearance(accountId: string) {
    return this.post('/authorizations/rerun-patient-account-clearance', { accountId })
  }
}
